<template>
  <div class="rfa">
    <!-- 收起 -->
    <div class="closeAslider">
      <!-- <div class="letter_box_close" @click="open_letter = true">
        <img src="@/assets/images/header/oldPlayLetter.png" alt="致老玩家的一封信">
      </div> -->
      <div class="openAsiderBox" @click="openBox">
        <p>展<br />开</p>
      </div>
      <dir class="goTopdIV">
        <p @click="goTop">TOP</p>
      </dir>
    </div>
    <!-- 展开 -->
    <div class="fixedAsilder">
      <!-- <div class="letter_box_open" @click="open_letter = true">
        <img src="@/assets/images/header/oldPlayLetter.png" alt="致老玩家的一封信">
      </div> -->
      <div class="silderBody">
        <ul class="wayUl">
          <li v-for="(sitem, sindex) in silderBtnList" :key="sindex" @click="wayLiClick(sitem)"
            @mouseenter="hoverInModal(sitem, sindex)" @mouseleave="hoverOutModal()">
            <img :src="sitem.img" :alt="sitem.text">
            <p>{{ sitem.text }}</p>
            <div class="codeModal" :class="{ codeActive: actCodeHoverIndex == sindex }">
              <img :src="sitem.erweima_code" :alt="sitem.text">
            </div>
          </li>
        </ul>
        <div class="wechat_box">
          <p>官方公众号</p>
          <div class="weImgBox">
            <div class="weerweima">
              <img :src="weChat_gzh" alt="官方公众号">
            </div>
          </div>
        </div>
        <div class="closeOrTop">
          <p @click="closeBox">收起</p>
          <p @click="goTop">TOP</p>
        </div>
      </div>
    </div>
    <!-- 致老玩家的一封信 -->
    <el-dialog class="letter-diaLog" :visible.sync="open_letter" width="1000px" :lock-scroll="false" :append-to-body="true" :close-on-click-modal="false"
      @close="open_letter = false">
      <div class="letter_content">
        <img src="@/assets/images/header/letterText.png" alt="致老玩家的一封信">
        <a class="old_player_bth" href="https://co.zhanhuo.com/welcome-back.html" target="_blank"></a>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'rightFixedArea',
  data() {
    return {
      open_letter: false,
      actCodeHoverIndex: -1,
      silderBtnList: [
        {
          url: 'https://space.bilibili.com/2097936606?spm_id_from=333.1007.0.0',
          img: require("@/assets/images/header/fixed_slide/b_icon.png"),
          text: 'B站',
          erweima_code: '',
        },
        {
          url: 'https://qm.qq.com/cgi-bin/qm/qr?k=EYii3awP3tJAJYmW53etnvgzChKjzbCg&jump_from=webapi',
          img: require("@/assets/images/header/fixed_slide/q_icon.png"),
          text: 'Q群',
          erweima_code: '',
        },
        {
          url: 'https://www.douyin.com/user/MS4wLjABAAAAApUBa7P_p6czezF1Wltoncw_VNbWD1vNe79UKG5QWPJnKkcl82Hl0afM9gxGy_In',
          img: require("@/assets/images/header/fixed_slide/dy_icon.png"),
          text: '抖音',
          erweima_code: require("@/assets/images/header/fixed_slide/dy_code.png"),
        },
        {
          url: 'https://www.kuaishou.com/profile/3x7nita8tqqqtkg',
          img: require("@/assets/images/header/fixed_slide/k_icon.png"),
          text: '快手',
          erweima_code: require("@/assets/images/header/fixed_slide/ks_code.png"),
        },
        {
          url: 'https://www.douyu.com/g_cszc',
          img: require("@/assets/images/header/fixed_slide/d_icon.png"),
          text: '斗鱼',
          erweima_code: '',
        },
        {
          url: 'https://www.huya.com/g/2741',
          img: require("@/assets/images/header/fixed_slide/h_icon.png"),
          text: '虎牙',
          erweima_code: '',
        },
      ],
      weChat_gzh: require("@/assets/images/header/fixed_slide/gzh.jpg"), // 官方公众号图片
    };
  },
  components: {},
  created() { },
  methods: {
    kefu() {
      showTypeCustomer();
    },
    // 一定高度为固定定位
    pageScroll() {
      this.removeTransition()
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop >= 630) {
        document.getElementsByClassName('closeAslider')[0].classList.add('isFixed')
        document.getElementsByClassName('fixedAsilder')[0].classList.add('isFixed')
      } else {
        document.getElementsByClassName('closeAslider')[0].classList.remove('isFixed')
        document.getElementsByClassName('fixedAsilder')[0].classList.remove('isFixed')
      }
    },
    // 回至顶部
    goTop() {
      this.removeTransition();
      this.$nextTick(() => {
        var arr = document.querySelectorAll('body')
        arr[0].scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        })
      });
      this.$bus.emit("goTopPage");
    },
    // 展开
    openBox() {
      $('.fixedAsilder').addClass('pagActive');
      $('.closeAslider').addClass('closeActive');
      this.addTransition()
    },
    // 收起
    closeBox() {
      $('.fixedAsilder').removeClass('pagActive');
      $('.closeAslider').removeClass('closeActive');
      this.addTransition()
    },
    addTransition() {
      $('.fixedAsilder').css('transition', 'all .5s ease-out');
      $('.closeAslider').css('transition', 'all .5s ease-out');
    },
    removeTransition() {
      $('.fixedAsilder').css('transition', 'none');
      $('.closeAslider').css('transition', 'none');
    },
    // 点击事件
    wayLiClick(item) {
      if (item.url != '') {
        window.open(item.url);
      } else {
        return
      }
    },

    // 侧边 鼠标hover事件
    hoverInModal(item, index) {
      if (item.text == '抖音') {
        this.actCodeHoverIndex = index
      } else if (item.text == '快手') {
        this.actCodeHoverIndex = index
      } else {
        this.actCodeHoverIndex = -1
      }
    },
    hoverOutModal() {
      this.actCodeHoverIndex = -1
    }
  },
  mounted() {
    window.addEventListener('scroll', this.pageScroll)
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", this.pageScroll);
  },
}
</script>
<style lang='scss' scoped>
.closeAslider {
  z-index: 999;
  position: absolute;
  right: -5px;
  top: 863px;
  width: 63px;
  height: 159px;
  background: url('~@/assets/images/header/fixed_slide/small_fixed_slider.png') no-repeat;
  background-size: 100% 100%;
  transform: translate(0, 0) scale(1);

  .letter_box_close {
    cursor: pointer;
    position: absolute;
    top: -160px;
    right: 10px;

    img {
      width: 140px;
      display: block;
      margin: 0 auto;
    }

    &:hover {
      img {
        -webkit-filter: brightness(110%);
        filter: brightness(110%);
      }
    }
  }

  .openAsiderBox {
    cursor: pointer;
    position: absolute;
    left: 8px;
    top: 3px;
    width: 50px;
    height: 77px;
    text-align: center;

    p {
      color: #fff;
      font-size: 24px;
      margin-top: 10px;
    }

    &:hover {
      p {
        color: #feab03;
      }
    }
  }

  .goTopdIV {
    cursor: pointer;
    position: absolute;
    left: 8px;
    bottom: 2px;
    width: 50px;
    height: 76px;
    text-align: center;
    line-height: 78px;

    p {
      color: #fff;
      font-size: 20px;

      &::after {
        content: "";
        position: absolute;
        left: 17px;
        top: 19px;
        width: 14px;
        height: 7px;
        background: url('~@/assets/images/header/fixed_slide/slderjt.png') no-repeat;
        transform: rotate(0deg);
      }

      &:hover {
        color: #feab03
      }
    }
  }

  &.closeActive {
    transform-origin: 100% 50%;
    transform: translate(450px, 0) scale(1);
  }

  &.isFixed {
    position: fixed;
    top: 250px;
  }
}

.fixedAsilder {
  z-index: 999;
  position: absolute;
  right: 20px;
  top: 800px;
  width: 173px;
  margin: 10px 0 0 20px;
  background: url('~@/assets/images/header/fixed_slide/slider_bagImg.png') no-repeat;
  background-size: 100% 100%;
  transform: translate(450px, 0) scale(1);

  .letter_box_open {
    cursor: pointer;
    position: absolute;
    top: -160px;

    img {
      width: 80%;
      display: block;
      margin: 0 auto;
    }

    &:hover {
      img {
        -webkit-filter: brightness(110%);
        filter: brightness(110%);
      }
    }
  }

  .silderBody {
    width: 144px;
    margin: 0 auto;

    .wayUl {
      margin-top: 20px;
      position: relative;

      li {
        position: relative;
        width: 144px;
        height: 39px;
        margin-top: 10px;
        background: url('~@/assets/images/header/fixed_slide/slider_btn.png') no-repeat;
        transition: all .3s ease-in-out;
        display: flex;
        justify-content: space-around;
        align-items: center;

        img {
          width: auto;
          margin-left: 10px;
        }

        p {
          margin-right: 10px;
          color: #fff;
          font-size: 18px;
        }

        &:hover {
          cursor: pointer;
          background: url('~@/assets/images/header/fixed_slide/slider_btn_a.png') no-repeat;
          background-size: 100% 100%;
        }

        .codeModal {
          display: none;
          position: absolute;
          left: -154px;
          top: 0px;
          width: 140px;
          height: 140px;
          background: url('~@/assets/images/header/fixed_slide/wechat_img.png') no-repeat;
          background-size: 100% 100%;

          img {
            width: 120px;
            height: 120px;
            margin: 10px;
          }

          &.codeActive {
            display: block;
          }
        }
      }

    }

    .wechat_box {
      text-align: center;
      margin: 10px auto;

      p {
        color: #fff;
        font-size: 20px;
        margin-bottom: 10px;
      }

      .weImgBox {
        overflow: hidden;
        width: 100%;
        height: 140px;
        background: url('~@/assets/images/header/fixed_slide/wechat_img.png') no-repeat;
        background-size: 100% 100%;

        .weerweima {
          width: 125px;
          height: 125px;
          margin: 10px 0 0 10px;

          img {
            width: 95%;
            height: 95%;
          }
        }
      }
    }

    .closeOrTop {
      text-align: center;

      p {
        cursor: pointer;
        font-size: 20px;

        &:nth-child(1) {
          position: relative;
          color: #feab03;
          margin: 10px 0;
          margin-bottom: 20px;

          &::after {
            content: "";
            position: absolute;
            left: 36px;
            top: 9px;
            width: 14px;
            height: 7px;
            background: url('~@/assets/images/header/fixed_slide/slderjt.png') no-repeat;
            transform: rotate(90deg);
          }

          &:hover {
            -webkit-filter: brightness(110%);
            filter: brightness(110%);
          }
        }

        &:nth-child(2) {
          position: relative;
          color: #fff;
          margin-bottom: 20px;

          &::after {
            content: "";
            position: absolute;
            left: 64px;
            top: -8px;
            width: 14px;
            height: 7px;
            background: url('~@/assets/images/header/fixed_slide/slderjt.png') no-repeat;
            transform: rotate(0deg);
          }

          &:hover {
            color: #feab03
          }
        }
      }
    }
  }

  &.pagActive {
    transform-origin: 100% 50%;
    transform: translate(0, 0) scale(1);
  }

  &.isFixed {
    position: fixed;
    top: 250px;
  }
}

.letter-diaLog {
  :deep(.el-dialog) {
    background-color: transparent;

    .el-dialog__header,
    .el-dialog__body {
      padding: 0 !important;
    }

    .el-dialog__headerbtn {
      z-index: 1;
      top: 6px;
      right: 6px;
      font-size: 32px;

      .el-dialog__close {
        color: #fff;
        transition: all .5s ease-in-out;

        &:hover {
          color: #feab03;
        }
      }
    }

    .letter_content {
      position: relative;

      a.old_player_bth {
        display: block;
        cursor: pointer;
        position: absolute;
        bottom: 400px;
        right: 0;
        left: 0;
        margin: auto;
        width: 298px;
        height: 68px;
        background: url('~@/assets/images/header/old_player_say.png') no-repeat;


        &:hover {
          -webkit-filter: brightness(110%);
          filter: brightness(110%);
        }
      }
    }

  }
}
</style>